module.exports = ".space {\n  height: 15px; }\n\n.desc {\n  margin-left: 10px;\n  font-style: italic;\n  color: #9b9b9b;\n  font-size: 14px; }\n\n.question {\n  margin-bottom: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/form-questionnaire/form-questionnaire.component.scss
// module id = ./src/app/shared/components/form-questionnaire/form-questionnaire.component.scss
// module chunks = main